'use strict';
import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class MasterConstant {

  public static ChangeHeaderHeightURLs = [
  //   { id: 1, name: '/failure/fcreation' },
  //   { id: 2, name: '/failure/fmanagement' },
    { id: 3, name: '/failure/fmapview' },
  //   { id: 4, name: '/admin/amanagement' },
  //   { id: 5, name: '/user/ualert' }
  ];

  public static DisableFooterURLs = [
    { id: 1, name: '/failure/fmapview' },
  ];

  public static Units = [
    { masterId: 1, name: 'Miles.Yards' },
    { masterId: 2, name: 'Miles.Chains' },
    { masterId: 3, name: 'Kilometers.Metres' },
  ];

  public static GlobalSearchFilter = [
    { id: '0', value: 'Failure Number' },
    { id: '1', value: 'Place' },
    { id: '2', value: 'Equipment Description' },
    { id: '3', value: 'Failure on' },
    { id: '4', value: 'Status' },
    { id: '5', value: 'Discipline' }
  ];

  public static TimerSnooze = [
    { value: 1, displayValue: '15 minutes' },
    { value: 2, displayValue: '1 hour' },
    { value: 3, displayValue: '4 hours' },
    { value: 4, displayValue: '1 day' }
  ];

  public static Monitoring = [
    { value: 'Y', name: 'Yes' },
    { value: 'N', name: 'No' },
  ];

  public static EquipmentClass = [
    { code: 'IN', name: 'In Development' },
    { code: 'EA', name: 'External Asset' },
    { code: 'FM', name: 'Fully Maintained' },
    { code: 'OR', name: 'Obsolete Record' },
    { code: 'PM', name: 'Partially Maintained' },
    { code: 'VD', name: '' }
  ];

  public static AssignmentStatus = [
    { title: 'Open', value: 'Open', edited: false, complete: false },
    { title: 'Accepted', value: 'Responded', edited: false, complete: false },
    { title: 'At site', value: 'At Site', edited: false, complete: false },
    { title: 'Work Started', value: 'Work Started', edited: false, complete: false },
    { title: 'Work Completed', value: 'Work Ended', edited: false, complete: false },
    { title: 'Closed', value: 'Closed', edited: false, complete: false },
  ];

  public static FailureEditStatus = [
    { title: 'Open', complete: true },
    { title: 'Assigned', complete: false },
    { title: 'Arrived', complete: false },
    { title: 'Approved', complete: false },
    { title: 'Work Started', complete: false },
    { title: 'Coded', complete: false },
    { title: 'Resolved', complete: false },
    { title: 'closed', complete: false },
  ];

  public static InternalTeam: number = 355940;

  public static AssignmentStatusId = { NotStarted: 355685 }

  public static AssignmentSubStatusId = {
    Unassigned: 355654,
    Closed: 355666,
    ControllerClosed: 355966
  }

}